import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { invoiceModel } from '~/models';
export const useAdHocInvoice = (invoiceId)=>{
    const { api } = useStoreActions();
    const { PAYMENT_LATE_RETURN_UI } = useFeatureFlags();
    const { data, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.Invoice,
            invoiceId
        ],
        queryFn: ()=>api.invoice.getByID(invoiceId, true).then((invoice)=>invoiceModel.coerceLateReturnWhenUiDisabled(invoice, !!PAYMENT_LATE_RETURN_UI)),
        enabled: !!invoiceId
    });
    return {
        invoice: data,
        isLoading,
        refresh
    };
};
